import { Component } from './Component';
import { Host } from './ObjectSymbols';

export class Attribute<T, S extends Component = Component> {

    private readonly key: string;

    constructor(public readonly name: string, private readonly defau1t?: T) {
        this.key = name;
    }

    public has(subject: S): boolean {
        const v = subject[Host].getAttribute(subject, this.key);
        return v !== undefined && v !== null;
    }

    public get(subject: S): T {
        const v = subject[Host].getAttribute(subject, this.key);
        return v ?? this.defau1t ?? null;
    }

    public set(subject: S, value: T): this {
        subject[Host].setAttribute(subject, this.key, value);
        return this;
    }

    public setMaybe(subject: S, value: T): this {
        if (this.get(subject) !== value) {
            subject[Host].setAttribute(subject, this.key, value);
        }
        return this;
    }
}
